var ids = {
  "login": {},
  "passwordReset": {},
  "hud": {
    "summaryCard": {},
    "priorityEvents": {
      "event": "hud_priorityEvents_event"
    }
  },
  "killbox": {
    "filters": {},
    "resultList": {
      "event": "killbox_resultList_event"
    },
    "details": {
      "event": {
        "dstIp": "killbox_details_event_dstIp",
        "dstPort": "killbox_details_event_dstPort",
        "dstDeviceId": "killbox_details_event_dstDeviceId",
        "endTime": "killbox_details_event_endTime",
        "observedTime": "killbox_details_event_observedTime",
        "srcIp": "killbox_details_event_srcIp",
        "srcPort": "killbox_details_event_srcPort",
        "srcDeviceId": "killbox_details_event_srcDeviceId",
        "startTime": "killbox_details_event_startTime",
        "streamViewerBtn": "killbox_details_event_streamViewerBtn",
        "streamViewer": {
          "viewTabBtns": {
            "ascii": "killbox_details_event_streamViewer_viewTabBtns_ascii",
            "hex": "killbox_details_event_streamViewer_viewTabBtns_hex",
            "raw": "killbox_details_event_streamViewer_viewTabBtns_raw"
          },
          "packetData": "killbox_details_event_streamViewer_packetData",
          "closeBtn": "killbox_details_event_streamViewer_closeBtn"
        },
        "threatScore": "killbox_details_event_threatScore",
        "title": "killbox_details_event_title",
        "type": "killbox_details_event_type"
      },
      "observation": {
        "dstIp": "killbox_details_observation_dstIp",
        "dstPort": "killbox_details_observation_dstPort",
        "dstDeviceId": "killbox_details_observation_dstDeviceId",
        "observedTime": "killbox_details_observation_observedTime",
        "occurredTime": "killbox_details_observation_occurredTime",
        "srcIp": "killbox_details_observation_srcIp",
        "srcPort": "killbox_details_observation_srcPort",
        "srcDeviceId": "killbox_details_observation_srcDeviceId",
        "streamViewerBtn": "killbox_details_observation_streamViewerBtn",
        "streamViewer": {
          "viewTabBtns": {
            "ascii": "killbox_details_observation_streamViewer_viewTabBtns_ascii",
            "hex": "killbox_details_observation_streamViewer_viewTabBtns_hex",
            "raw": "killbox_details_observation_streamViewer_viewTabBtns_raw"
          },
          "packetData": "killbox_details_observation_streamViewer_packetData",
          "closeBtn": "killbox_details_observation_streamViewer_closeBtn"
        },
        "threatScore": "killbox_details_observation_threatScore",
        "title": "killbox_details_observation_title",
        "type": "killbox_details_observation_type"
      }
    }
  },
  "explorer": {},
  "sitrep": {},
  "settings": {},
  "profiler": {},
  "panLogViewer": {},
  "intelCard": {
    "ip": {},
    "url": {},
    "file": {}
  },
  "sensorCommandConsole": {},
  "intel": {
    "addListBtn": "intel_addListBtn",
    "addIntelBtn": "intel_addIntelBtn",
    "createListForm": {
      "nameInput": "intel_createListForm_nameInput",
      "saveBtn": "intel_createListForm_saveBtn",
      "cancelBtn": "intel_createListForm_cancelBtn",
      "errorNotification": "intel_createListForm_errorNotification"
    },
    "list": {
      "dotMenu": "intel_list_dotMenu",
      "deleteListOpt": "intel_list_deleteListOpt",
      "renameListOpt": "intel_list_renameListOpt",
      "deleteListConfirmBtn": "intel_list_deleteListConfirmBtn"
    },
    "tabOverview": "intel_tabOverview",
    "tabManage": "intel_tabManage",
    "overview": {},
    "manage": {
      "tableActionHeader": "intel_manage_tableActionHeader"
    }
  }
}

function getValue (object, propertyName) {
  if (object.hasOwnProperty(propertyName)) {
    return object[propertyName]
  } else {
    throw new Error("Invalid Test ID/path requestsd: " + propertyName)
  }
}

function getTestId (path) {
  if (!ids) {
    throw new Error('No Test IDs available')
  }
  var pathComponents = path.split('.')
  var prop = ''
  var currentObj = ids
  while (prop = pathComponents.shift()) {
    var val = getValue(currentObj, prop)
    if (typeof val === "object") {
      currentObj = val
    } else {
      return val // ID name found
    }
  }
}

module.exports.__esModule = true // Match babel6's cjs output format
module.exports['default'] = getTestId
